import { render, staticRenderFns } from "./DataWalls.vue?vue&type=template&id=7131e16a&scoped=true"
import script from "./DataWalls.vue?vue&type=script&lang=js"
export * from "./DataWalls.vue?vue&type=script&lang=js"
import style0 from "./DataWalls.vue?vue&type=style&index=0&id=7131e16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131e16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VLayout,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems})
